import React from "react";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import {
    StyledLabel,
    StyledSelectInput,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { ArrowDownIcon } from "@components/Common/SvgIcons/ArrowDownIcon";
import { components } from "react-select";
import { SupportCodeModal } from "./SupportCodeModal";
import { ipMatchWord } from "@constants/index";

import { useMoneticsForm } from "./MoneticsFormContext";
import {
    COMMUNICATION_OPTIONS,
    COMMUNICATION_LOCAL,
    MONETIC_MODE_TEST,
    MONETIC_MODE_PRODUCTION,
} from "./moneticsConstants";
import { FieldError } from "./components/FieldError";

export function YavinConfig() {
    const { form, props } = useMoneticsForm();
    const {
        setMode,
        mode,
        ipAddress,
        setIpAddress,
        keyValue,
        setKey,
        inputKey,
        setInputKey,
        serialNumber,
        setSerialNumber,
        inputSerialNumber,
        setInputSerialNumber,
        communication,
        setCommunication,
        port,
        setPort,
        portSelectInput,
        setPortSelectInput,
    } = form;
    const {
        setIsEdited,
        isConsult,
        InputIp: inputIp,
        setInputIp,
        ipExist,
    } = props;
    const { t } = useTranslation();
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [, setIsConfigurationModalOpened] = React.useState<boolean>(false);
    const [codeSupport, setCodeSupport] = React.useState<string>("");
    const [isValidCode, setIsValidCode] = React.useState(false);
    let communications = COMMUNICATION_OPTIONS;

    const DropdownIndicator = (props: any) => {
        return isValidCode === true || codeSupport === "" ? (
            <span
                onClick={() => {
                    setIsModalOpened(true);
                }}
                style={{
                    color: "hsl(0,0%,80%)",
                    width: "38px",
                }}
            >
                <ArrowDownIcon
                    fill="currentColor"
                    style={{ marginLeft: "8px" }}
                />
            </span>
        ) : (
            <components.DropdownIndicator {...props}>
                <ArrowDownIcon fill="currentColor" />
            </components.DropdownIndicator>
        );
    };
    return (
        <React.Fragment>
            <AvForm>
                <AvGroup>
                    <StyledLabel
                        htmlFor="payment type"
                        className="required__clz mt-3"
                    >
                        {t("Mode")}
                    </StyledLabel>
                    <StyledSelectInput
                        data-testid="monetics-yavin-mode-select"
                        disabled
                        components={{ DropdownIndicator }}
                        className={classnames("mnt_drp_mode", {
                            readOnly__clz: isConsult,
                        })}
                        name="mode"
                        required
                        options={
                            codeSupport === ""
                                ? []
                                : [
                                      {
                                          label: MONETIC_MODE_TEST,
                                          value: MONETIC_MODE_TEST,
                                      },
                                      {
                                          label: MONETIC_MODE_PRODUCTION,
                                          value: MONETIC_MODE_PRODUCTION,
                                      },
                                  ]
                        }
                        placeholder={t("Select")}
                        onChange={(e: any) => {
                            setMode(e.label);
                            setIsEdited(true);
                        }}
                        value={{ label: mode, value: mode }}
                        onFocus={() => {
                            if (codeSupport === "") {
                                setIsModalOpened(true);
                            }
                        }}
                    />
                </AvGroup>
                <AvGroup>
                    <StyledLabel className="mt-3 required__clz" htmlFor="text">
                        {t("Port number")}
                    </StyledLabel>
                    <AvField
                        data-testid="monetics-yavin-port-input"
                        className={classnames("mnt_inp_portNumber", {
                            invalid__clz: portSelectInput,
                            readOnly__clz: isConsult,
                        })}
                        autocomplete="off"
                        id="port"
                        name="port"
                        placeholder={t("Write")}
                        type="number"
                        onChange={(e: any) => {
                            setPortSelectInput(false);
                            setPort(e.target.value);
                            setIsEdited(true);
                        }}
                        value={port}
                    />

                    {portSelectInput && (
                        <FieldError>
                            {t("Please select a port number")}
                        </FieldError>
                    )}
                </AvGroup>
                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="required__clz mt-3"
                    >
                        {t("Communication")}
                    </StyledLabel>
                    <StyledSelectInput
                        data-testid="monetics-yavin-communication-select"
                        name="communications_input"
                        id="communications_input"
                        options={communications}
                        onChange={(e: any) => {
                            setCommunication(e.label);
                            setInputIp(false);
                            setInputKey(false);
                            setInputSerialNumber(false);
                            setIpAddress("");
                            setIsEdited(true);
                        }}
                        placeholder={t("Select")}
                        value={
                            communication !== ""
                                ? {
                                      value: communication,
                                      label: communication,
                                  }
                                : null
                        }
                        noOptionsMessage={() => t("No options")}
                        maxMenuHeight="90px"
                        className={classnames("mnt_drp_communication", {
                            readOnly__clz: isConsult,
                        })}
                    />
                </AvGroup>{" "}
                {communication === COMMUNICATION_LOCAL ? (
                    <AvGroup>
                        <StyledLabel
                            htmlFor="example-input"
                            className="mt-3 required__clz"
                        >
                            {t("IP address")}
                        </StyledLabel>
                        <AvField
                            data-testid="monetics-yavin-ip-input"
                            className={classnames("mnt_inp_ipAdress", {
                                input__clz: inputIp || ipExist,
                                readOnly__clz: isConsult,
                            })}
                            autocomplete="off"
                            id="ipAddress"
                            name="ipAddress"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                setIpAddress(e.target.value);
                                if (
                                    !e.target.value.match(ipMatchWord) &&
                                    e.target.value !== ""
                                ) {
                                    setInputIp(true);
                                } else {
                                    setInputIp(false);
                                }
                                setIsEdited(true);
                            }}
                            value={ipAddress}
                        />
                        {inputIp || ipExist ? (
                            <FieldError>
                                {t(
                                    ipAddress === ""
                                        ? "Please enter a IP address"
                                        : !ipAddress.match(ipMatchWord)
                                        ? "IP address is invalid"
                                        : ipExist
                                        ? "The ip address is already exists"
                                        : ""
                                )}
                            </FieldError>
                        ) : null}
                    </AvGroup>
                ) : (
                    <React.Fragment>
                        <AvGroup>
                            <StyledLabel
                                htmlFor="text"
                                className="mt-3 required__clz"
                            >
                                {t("Key")}
                            </StyledLabel>
                            <StyledTextInput
                                data-testid="monetics-yavin-key-input"
                                id="Key-input"
                                name="Key-input"
                                placeholder={t("Write")}
                                value={keyValue}
                                onChange={(e: any) => {
                                    setKey(e.target.value.trim());
                                    setInputKey(false);
                                    setIsEdited(true);
                                }}
                                className={classnames("mnt_inp_Key", {
                                    input__clz: inputKey,
                                    readOnly__clz: isConsult,
                                })}
                            />
                            {inputKey ? (
                                <FieldError>
                                    {t("Please enter a key")}
                                </FieldError>
                            ) : null}
                        </AvGroup>
                        <AvGroup>
                            <StyledLabel
                                htmlFor="text"
                                className="mt-3 required__clz"
                            >
                                {t("TPE Serial Number")}
                            </StyledLabel>
                            <StyledTextInput
                                data-testid="monetics-yavin-serial-number-input"
                                type="text"
                                id="serial-number"
                                name="serial-number"
                                placeholder={t("Write")}
                                value={serialNumber}
                                onChange={(e: any) => {
                                    setSerialNumber(e.target.value.trim());
                                    setInputSerialNumber(false);
                                    setIsEdited(true);
                                }}
                                className={classnames("mnt_inp_Key", {
                                    input__clz: inputSerialNumber,
                                    readOnly__clz: isConsult,
                                })}
                            />
                            {inputSerialNumber ? (
                                <FieldError style={{ color: "red" }}>
                                    {t("Please enter a TPE serial number")}
                                </FieldError>
                            ) : null}
                        </AvGroup>
                    </React.Fragment>
                )}
            </AvForm>
            {isModalOpened ? (
                <SupportCodeModal
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    codeSupport={codeSupport}
                    setCodeSupport={setCodeSupport}
                    isValidCode={isValidCode}
                    setIsValidCode={setIsValidCode}
                    isConfig={false}
                    setIsModalConfigOpened={setIsConfigurationModalOpened}
                />
            ) : null}
        </React.Fragment>
    );
}
